import App from "./components/app";
import "./style";
export default App;
